// extracted by mini-css-extract-plugin
module.exports = {"EledoLogin":"EledoPageHeader_EledoLogin__jsJkH"};